/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Offers1Inputs */

const id_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran`)
};

const ms_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran`)
};

const da_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const de_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebote`)
};

const en_us2_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

const es_es2_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const es_mx2_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const fil_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Offer`)
};

const fr_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres`)
};

const it_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte`)
};

const hu_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlatok`)
};

const nl_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbiedingen`)
};

const no_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const pl_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferty`)
};

const pt_br2_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

const pt_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas`)
};

const ro_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte`)
};

const fi_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjoukset`)
};

const sv_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudanden`)
};

const vi_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi`)
};

const tr_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklifler`)
};

const cs_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const bg_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оферти`)
};

const ru_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предложения`)
};

const uk_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропозиції`)
};

const ar_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض`)
};

const hi_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र`)
};

const th_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอ`)
};

const ja_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファー`)
};

const zh_cn2_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

const zh_hant1_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

const ko_components_sandboxshell_offers1 = /** @type {(inputs: Components_Sandboxshell_Offers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offers`)
};

/**
* | output |
* | --- |
* | "Offers" |
*
* @param {Components_Sandboxshell_Offers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_offers1 = /** @type {((inputs?: Components_Sandboxshell_Offers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Offers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_offers1(inputs)
	if (locale === "ms") return ms_components_sandboxshell_offers1(inputs)
	if (locale === "da") return da_components_sandboxshell_offers1(inputs)
	if (locale === "de") return de_components_sandboxshell_offers1(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_offers1(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_offers1(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_offers1(inputs)
	if (locale === "fil") return fil_components_sandboxshell_offers1(inputs)
	if (locale === "fr") return fr_components_sandboxshell_offers1(inputs)
	if (locale === "it") return it_components_sandboxshell_offers1(inputs)
	if (locale === "hu") return hu_components_sandboxshell_offers1(inputs)
	if (locale === "nl") return nl_components_sandboxshell_offers1(inputs)
	if (locale === "no") return no_components_sandboxshell_offers1(inputs)
	if (locale === "pl") return pl_components_sandboxshell_offers1(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_offers1(inputs)
	if (locale === "pt") return pt_components_sandboxshell_offers1(inputs)
	if (locale === "ro") return ro_components_sandboxshell_offers1(inputs)
	if (locale === "fi") return fi_components_sandboxshell_offers1(inputs)
	if (locale === "sv") return sv_components_sandboxshell_offers1(inputs)
	if (locale === "vi") return vi_components_sandboxshell_offers1(inputs)
	if (locale === "tr") return tr_components_sandboxshell_offers1(inputs)
	if (locale === "cs") return cs_components_sandboxshell_offers1(inputs)
	if (locale === "bg") return bg_components_sandboxshell_offers1(inputs)
	if (locale === "ru") return ru_components_sandboxshell_offers1(inputs)
	if (locale === "uk") return uk_components_sandboxshell_offers1(inputs)
	if (locale === "ar") return ar_components_sandboxshell_offers1(inputs)
	if (locale === "hi") return hi_components_sandboxshell_offers1(inputs)
	if (locale === "th") return th_components_sandboxshell_offers1(inputs)
	if (locale === "ja") return ja_components_sandboxshell_offers1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_offers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_offers1(inputs)
	return ko_components_sandboxshell_offers1(inputs)
});
export { components_sandboxshell_offers1 as "components.sandboxShell.offers" }